import FlaskIcon from './FlaskIcon';
import HeartIcon from './HeartIcon';
import MunchIcon from './MunchIcon';
import PodiumIcon from './PodiumIcon';
import MoleculeIcon from './MoleculeIcon';

export { FlaskIcon, HeartIcon, MoleculeIcon, MunchIcon, PodiumIcon };



// WEBPACK FOOTER //
// ./src/components/AnimatedIcons/index.js